import { isNil, isArray, isPlainObject, isObjectLike } from 'gleam-shared/helpers/nodash'

export default function updateQuery(url = '/', query = {}) {
  const pairs = sortedEntries(query)

  if (pairs.length === 0) {
    return url
  }

  const obj = new URL(url, document.location.origin)
  const hadOrigin = url.startsWith(obj.origin)

  for (const [key, value] of pairs) {
    if (isObjectLike(value)) {
      for (const { path, nestedValue, shouldAppend, shouldDelete } of nestedEntries(key, value)) {
        if (shouldDelete) {
          obj.searchParams.delete(path)
        } else if (shouldAppend) {
          obj.searchParams.append(path, nestedValue)
        } else {
          obj.searchParams.set(path, nestedValue)
        }
      }
    } else if (isNil(value)) {
      obj.searchParams.delete(key)
    } else {
      obj.searchParams.set(key, value)
    }
  }

  if (hadOrigin) {
    return obj.toString()
  } else {
    return obj.toString().replace(obj.origin, '')
  }
}

function nestedEntries(parent, value, shouldAppend = false) {
  if (isArray(value)) {
    const path = `${parent}[]`
    const toDelete = { path, shouldDelete: true }
    const toAppend = value.flatMap((nestedValue) => {
      return nestedEntries(path, nestedValue, true)
    })

    return [toDelete, ...toAppend]
  } else if (isPlainObject(value)) {
    return sortedEntries(value).flatMap(([key, nestedValue]) => {
      const path = `${parent}[${key}]`
      return nestedEntries(path, nestedValue)
    })
  } else if (isNil(value) && !shouldAppend) {
    // can delete an object key but not an array element because array elements aren't indexed
    return {
      path: parent,
      shouldDelete: true
    }
  } else {
    return [{
      path: parent,
      nestedValue: value,
      shouldAppend
    }]
  }
}

function sortedEntries(value) {
  return Object.entries(value).sort(([keyA], [keyB]) => {
    return keyA.localeCompare(keyB)
  })
}
